/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Dropdown_MobileInputs */

const en_downloads_dropdown_mobile = /** @type {(inputs: Downloads_Dropdown_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobile`)
};

const es_downloads_dropdown_mobile = /** @type {(inputs: Downloads_Dropdown_MobileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Móvil`)
};

/**
* | output |
* | --- |
* | "Mobile" |
*
* @param {Downloads_Dropdown_MobileInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_dropdown_mobile = /** @type {((inputs?: Downloads_Dropdown_MobileInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Dropdown_MobileInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_dropdown_mobile(inputs)
	return en_downloads_dropdown_mobile(inputs)
});